import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '@/app/pages/LoginPage';
import ProtectedRoute from './ProtectedRoute';
import { MobileLayout } from '@/components/layout/MobileLayout';
import NotificationsPage from '@/app/pages/notifications/NotificationsPage';
import NotificationDetailPage from '@/app/pages/notifications/NotificationDetailPage';
import ProfilePage from '@/app/pages/profile/ProfilePage';
import PartyDashboardPage from '@/app/pages/parties/PartyDashboardPage';
import PartiesPage from '@/app/pages/parties/PartiesPage';
import PartyDetailPage from '@/app/pages/parties/PartyDetailPage';
import NewPaymentInPage from '@/app/pages/payments-in/NewPaymentInPage';
import NewSalesOrderPage from '@/app/pages/sales-orders/NewSalesOrderPage';
import MySalesOrdersPage from '@/app/pages/sales-orders/MySalesOrdersPage';
import SalesOrderDetailPage from '@/app/pages/sales-orders/SalesOrderDetailPage';
import LeadsPage from '@/app/pages/leads/LeadsPage';
import NewLeadPage from '@/app/pages/leads/NewLeadPage';
import LeadDetailPage from '@/app/pages/leads/LeadDetailPage';

export default function AppRouter() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Public routes */}
                <Route path="/login" element={<LoginPage />} />

                {/* Protected routes */}
                <Route element={<ProtectedRoute />}>
                    {/* Full-screen flows (no tab bar) */}
                    <Route path="/payments-in/new" element={<NewPaymentInPage />} />
                    <Route
                        path="/payments-in"
                        element={<Navigate to="/payments-in/new" replace />}
                    />
                    <Route path="/sales-orders/new" element={<NewSalesOrderPage />} />
                    {/* Editing an order is the same full-screen product-picking flow as
                        creating one, so it stays outside the tab-bar layout too. */}
                    <Route path="/sales-orders/:id" element={<SalesOrderDetailPage />} />
                    <Route path="/leads/new" element={<NewLeadPage />} />

                    {/* Routes with mobile layout + tab bar */}
                    <Route element={<MobileLayout />}>
                        <Route path="/notifications" element={<NotificationsPage />} />
                        <Route path="/notifications/:id" element={<NotificationDetailPage />} />
                        <Route path="/leads" element={<LeadsPage />} />
                        <Route path="/leads/:id" element={<LeadDetailPage />} />
                        <Route path="/parties" element={<PartyDashboardPage />} />
                        <Route path="/parties/list" element={<PartiesPage />} />
                        <Route path="/parties/:id" element={<PartyDetailPage />} />
                        <Route path="/sales-orders" element={<MySalesOrdersPage />} />
                        <Route path="/settings" element={<Navigate to="/profile" replace />} />
                        <Route path="/profile" element={<ProfilePage />} />
                    </Route>
                </Route>

                {/* Default redirects */}
                {/* Land on Leads: Alerts no longer has a tab, so landing there left
                    the app with no tab selected. Alerts is reached from Profile. */}
                <Route path="/" element={<Navigate to="/leads" replace />} />
                <Route path="*" element={<Navigate to="/leads" replace />} />
            </Routes>
        </BrowserRouter>
    );
}
